import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-modal-table-analytics',
  templateUrl: './app-modal-table-analytics.component.html'
})

export class AppModalTableAnalyticsComponent implements OnInit {

  modalRef: BsModalRef;
  @Input() data: Object;
  @Input() label: string;
  @Input() showUsersCount?: boolean;

  constructor(private modalService: BsModalService) {
  }

  openModal(template: TemplateRef<any>) {
    if (this.data) {
      // console.log(this.data);
    }
    this.modalRef = this.modalService.show(template, { 'class': 'modal-lg' });
  }

  ngOnInit() {
  }
}
